import React from 'react';
import { MarkerSearchResult } from './';

export function MarkerSearchResults({ results, onSelect }) {
  // console.log('RESULTS LIST', results);

  const handleMarkerSelect = (markerType) => {
    // console.log('Result', markerType);
    if (onSelect) onSelect(markerType);
  };

  return (
    <div className="chronos-marker-template-search-results">
      {results &&
        results.map((result) => (
          <MarkerSearchResult
            markerType={result}
            onMarkerClick={handleMarkerSelect}
            key={result.waID}
          />
        ))}
      {(!results || results.length === 0) && (
        <div className="chronos-marker-template-search-empty">
          <span>No Results Found</span>
        </div>
      )}
    </div>
  );
}
